<!--header-->
<header class="top-header">
	<nav class="navbar navbar-expand" style="background-color: #fff;">
		<div class="container">
      <div class="d-flex col-12">
        <div class="col-6 col-md-auto mt-3" style="margin-left: -14px;">
          <img
          src="../../../assets/images/logo (2).png"
          class="logo-icon-2 cursor-pointer"
          alt="" [routerLink]="['/']" />
        </div>
        <div class="col mt-3" style="margin-left:  11px !important;">
          <div class="headRight mt-2">
            <div class="d-lg-none">
                <img width="38px" *ngIf="!toogleBtn" (click)="toogleBtn=!toogleBtn" src="../../../assets/images/menu-icon.svg" class="mt-1 cursor-pointer">
                <img class="mt-2 cursor-pointer" *ngIf="toogleBtn" width="22px" (click)="toogleBtn=!toogleBtn" src="../../../assets/images/crossIcon.svg">
                <div class="sidenav-panel" *ngIf="toogleBtn">
                  <p *ngIf="!token" [routerLink]="['/email-signup']" (click)="toogleBtn=!toogleBtn" style="color: #fff;font-size: 14px;font-weight: 500;">Email Sign-Up</p>
                  
                  <p *ngIf="token" [routerLink]="['/account-detail']" (click)="toogleBtn=!toogleBtn" style="color: #fff;font-size: 14px;font-weight: 500;">My Account</p>
                  <div *ngFor="let data of titlesAndIdsArray2 ">
                    <div [routerLink]="['/resources', data.slug]">
                        <p [routerLink]="['/resources', data.slug]" (click)="toogleBtn=!toogleBtn" style="color: #fff;font-size: 14px;font-weight: 500;" class="ps-2">{{data?.title}}</p>
                    </div>
                  </div>
                  <p [routerLink]="['/add-wishlist']"  (click)="toogleBtn=!toogleBtn"style="color: #fff;font-size: 14px;font-weight: 500;"> Order Guide [ {{wishcart}} ]</p>
                  <p [routerLink]="['/my-cart-list']" (click)="toogleBtn=!toogleBtn" style="color: #fff;font-size: 14px;font-weight: 500;"> My cart [ {{ wishlist | number:'1.0-2'}} ] ${{carttotalt | number:'1.0-2'}}</p>
                  <p *ngIf="token" style="color: #fff;font-size: 14px;font-weight: 500;" (click)="logoutaccount()" (click)="toogleBtn=!toogleBtn">Log Out </p>
              </div>
            </div>
           
            
            <div class="d-none d-lg-block">
              <ul class="d-flex justify-content-end flex-wrap"> <!-- Modified line -->
                <li style="height: max-content" *ngIf="token">
                    <a style="color:#F44C4C;font-size: 14px;font-weight: 400;" (click)="logoutaccount()">Log Out </a>
                </li>
                <li style="height: max-content" *ngIf="token">
                    <p class="ms-2 mb-0"> |</p>                
                </li>
                <li style="height: max-content" *ngIf="token">
                    <p [routerLink]="['/account-detail']" style="color: #000000;font-size: 14px;font-weight: 400;" class="mb-0">My Account</p>
                </li>
                <li style="height: max-content" *ngIf="token">
                    <p class="ms-2 mb-0">|</p>
                </li>
                <li style="height: max-content" *ngIf="!token">
                    <p  [routerLink]="['/email-signup']"style="color: #000000;font-size: 14px;font-weight: 400;" class="mb-0">Email Sign-Up</p>
                </li>
                <li style="height: max-content" *ngIf="!token">
                  <p class="ms-2 mb-0">|</p>
                </li>
                <div *ngFor="let data of titlesAndIdsArray2 " style="height: max-content;">
                    <li style="height: max-content" [routerLink]="['/resources', data.slug]">
                        <p [routerLink]="['/resources', data.slug]" style="color: #000000;font-size: 14px;font-weight: 400;" class="ps-2 mb-0">{{data?.title}}  <span class="ms-2">|</span></p>
                    </li>
                </div>
              </ul>
            </div>
          </div>
      
         </div>
        </div>


    </div>


	</nav>
  <div class="topMenus" style="border: 1px solid #F2F4F5 !important;">
    <div class="container mt-2">
      <div class="d-flex col-lg-12 col-md-12 col-sm-12 col-xs-12 d-block-mb">
      <!-- <div class="col-lg-2 col-md-2 col-sm-3 col-xs-6 mt-0">
        <img src="/assets/images/categoryicon.png" class="catImg">
        <span class="text-white">All Category</span>
      </div> -->
      <div  class="col-lg-6 col-md-5 col-sm-12 col-xs-12" >
        <form class="form" [formGroup]="searchproduct" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3">
            <!-- <span class="SerchText">Search</span> -->
            <div class="searchDiv d-flex">
              <!--             
                          <input placeholder="Search by Product Name" name="search_param" id="search-box" value="" autocomplete="off" style="height:34px" class="form-control">
                          <i class="ri-search-line search-icon"></i> 
                         -->
              
                        <div class="input-group mb-2 pb-1 d-flex flex-nowrap">
                    
                        <div class="input-group-prepend">
                          <a class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" 
                          aria-expanded="false"  style="box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);background-color: #F3F3F3;height: 40px;padding-top: 9px;border-radius: 2px;">All Categories</a>
                          <div class="dropdown-menu" style="border-radius: 1px;border-radius: 0px;height: 60vh;overflow-x: auto;cursor: pointer;">
                            <a class="dropdown-item" *ngFor="let data of category" (click)="getallselectcategory(data?.categoryId, data?.categoryName)">
                              <img [src]="data?.image || 'assets/images/download (20).png'" onerror="this.src='assets/images/download (20).png';" style="width: 28px; height: 23px; border-radius: 1px;">
                              <span class="p-3" style="font-size: 16px; line-height: 28px; font-weight: 400;">{{data?.categoryName}}</span>
                            </a>
                          </div>
                        </div>
                     
                        <!-- <input type="text" class="form-control" aria-label="Text input with dropdown button" placeholder="Search by Product Name"> -->
                        <!-- <input class="form-select" type="search" id="example-search-input" placeholder="   Search for item "> -->
                         <!-- <select (change)="onProductSelected()" class="form-select " style=" box-shadow: none!important;" formControlName="name" style="background-color: #F3F3F3;border:none">
                          
                          <i class="las la-caret-down"></i>
                          <option disabled selected value="" style="background-color: white;">Select a product</option>
                          <option *ngFor="let data of product"  [value]="data.productId" style="font-size:16px;line-height: 28px;font-weight: 400;cursor: pointer;background-color: white;">{{data.productName}}
                          </option>
                        </select> -->
                        <div class="ms-3 ser-div" #dropdownWrapper>
                          <div class="d-flex">
                              <input type="text" class="form-control" style="border-radius: 2px 0px 0px 2px !important;background: #F3F3F3;border: none; " aria-label="Text input with dropdown button" placeholder="Search by Product Name" formControlName="productname" (keyup)="handleKeyUp($event)" (input)="specialitySearch($event);getallproduct()" (click)="onProductSelected($event)">
                              <div>
                                  <button class="btn btn-primary input-group-append text-white" (click)="searchproductbyname()" style="background-color: #F44C4C;     border-radius: 0px 3px 3px 0px; padding: 2px; cursor: pointer; border: white; height: 40px;" >
                                      <i class='bx bx-search' style="font-size: 23px; margin-top: -21px; border-radius: 0px 9px 9px 0px; padding: 10px;"></i>
                                  </button>
                              </div>
                          </div>
                          <div>
                              <ul *ngIf="showDropdown && product.length > 0" class="card dd-p" style="position: absolute;width: 490px;margin-left: -1px;height: 400px;overflow-x: auto;">
                                  <li *ngFor="let data of product" style="white-space: break-spaces;margin-left: -24px;margin-top: 14px;cursor:pointer;" [value]="data?.productId" (click)="updateInput(data?.productName)">
                                      {{data?.productName}}
                                  </li>
                              </ul>
                          </div>
                      </div>
       
                   <div class=""> 
                    <!-- <button class="btn btn-primary" class="input-group-append text-white" style="background-color: #F44C4C;border-radius: 3px;padding: 2px;cursor:pointer;border: white;
                    height: 40px;"(click)="clear()">
                      
                      <i class='bx bx-search' style="font-size: 23px;margin-top: -10px;border-radius: 0px 9px 9px 0px;padding:10px;"></i>
                    </button> -->
                   </div>
                       
                       
                      
                        </div>
              
                       </div> 
           </div>
        </form>
      </div>
       <div class="col-lg-6 col-md-7 col-sm-12 col-xs-12 d-none d-md-block" style="text-align: end;margin-left:10px">
      <div class="cartDiv d-flex justify-content-end">
       <div class="wishlist" style="margin-top: 9px;" (click)="goToOrderGuide('/add-wishlist')">
        <a style="color:#fff">
          <i class="bx bx-heart " style="color: #fff; font-size: 34px;position:absolute;margin-left: -31px;margin-top: -16px;">
          </i>
           <span class=" position-absolute topbar-badge fs-3xs translate-middle badge rounded-pill" style="background-color: #fff;color: #F43C4C; margin-top:-6px;height: 18px;width: 18px;padding: 5px 4px;">{{wishcart}}</span>
          <!-- <p style="color: black; font-size: 10px;">{{wishlist}}</p> -->
          <!-- <span class="m-3" [routerLink]="['/add-wishlist']"  style="color:#fff"> Order Guide</span> -->
          <span class="m-3" style="color:#fff"> Order Guide</span>
         </a>
       </div>
       <div class="mycart" (click)="goToCart('/my-cart-list')">
        <a style="color:#fff ; margin-left:72px">
          <i class="las la-shopping-cart " style="font-size: 37px;position: absolute; margin-left: -34px;color: #fff;"></i>
          <span class="position-absolute topbar-badge fs-3xs translate-middle badge rounded-pill mt-1" style="background-color: #fff;color: #F43C4C;">{{wishlist}}</span>
          <!-- <span class="m-3" [routerLink]="['/my-cart-list']" style="color:#fff">My cart</span><br> -->
          <span class="m-3" style="color:#fff">My cart</span><br>
          <span style="color:#fff;font-size: 12px;font-weight: 400;line-height: 14px;font-family: 'Microsoft Sans Serif', sans-serif; ;">${{carttotalt | number:'1.0-2'}}</span>
       
        
         </a>
       </div>
       
      
      <div class="signin">
        <a class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border: none; margin-left: 20px;">
          <img *ngIf="logindetail?.image" [src]="logindetail?.image || 'assets/images/bsup.svg'" onerror="this.src='assets/images/bsup.svg';" width="30" height="30" alt="" class="rounded-circle header-profile-user">
          <img *ngIf="!logindetail?.image" src="assets/images/bsup.svg" width="30" height="30" alt="" class="rounded-circle header-profile-user">
           <a  class="ms-1" style="color: #fff;"> {{logindetail?.name || 'sign In'}} </a>
       
          <div class="dropdown-menu dd-menu mt-2" #dropdownMenu aria-labelledby="dropdownMenuLink">
            <p class="p-2 text-start mb-0 ms-2 ddm-h" *ngIf="token" (click)="logoutaccount()">Log Out</p>
            <div style="border-radius: 7px; width: 424px;" *ngIf="!token">
              <div class="col-md-12 col-lg-12 col-xl-12 ps-5 mt-3 d-flex">
                <div class="col-md-6" (click)="showSignInForm($event)">
                 <h5 *ngIf="showLine3InSignIn" style="font-size: 20px;font-weight: 500;line-height: 28px;color: black;">Sign In</h5>
                 <h5 *ngIf="showLine4InSignIn"  style="font-size: 20px;font-weight: 500;line-height: 28px;color:#77878F">Sign In</h5>
  
                 <div>
                  <img *ngIf="showLine3InSignIn" src="../../../assets/images/line 3.png" class="" style="width: 203px;margin-left: -46px;height: 2px;">
                  <img *ngIf="showLine4InSignIn" src="../../../assets/images/line 4.png" class="" style="width: 225px;margin-left: -46px;height: 2px;">
              </div>
                </div>  
                <div class="col-md-6" (click)="showSignUpForm($event)">
                  <h5 *ngIf="showLine3InSignUp" style="font-size: 20px;font-weight: 500;line-height: 28px;color: black;" >Sign Up</h5>
                  <h5 *ngIf="showLine4InSignUp"  style="font-size: 20px;font-weight: 500;line-height: 28px;color:#77878F" >Sign Up</h5>
  
                  <div>     
                    <img *ngIf="showLine3InSignUp" src="../../../assets/images/line 3.png" class="" style="width: 225px;margin-left: -38px;height: 2px;">
                    <img *ngIf="showLine4InSignUp" src="../../../assets/images/line 4.png" class="" style="width: 225px;margin-left: -31px;height: 2px;">
                </div>
                  <!-- <div>
                    <img src="../../../assets/images/line 1.png"  class="" style="width: 203px;margin-left: -46px;height: 2px;"   >
                </div> -->
                </div>
                
               
              </div>
              <!-- <hr class="mt-1" style="border-radius:2px;color:
              #FA8232;height: 2px;border: 2px;"> -->
              <div class="col-md-12 col-md-12 col-lg-12 col-xl-12  p-3 " *ngIf="showSignIn">
               <div *ngIf="loginn==true" >
                <form class="g-3"  [formGroup]="formGroup"    >
                  <div class="col-md-6 m-3">
                      <div class="form-group">
                          <label for="" class="form-label">Email Address </label>
                          <div class="input-group" style="width: 177%;">
                              <input type="text" placeholder="" class="form-control" formControlName="email" (click)="stopPropagation($event)">
                          </div>
                          <mat-error>
                            <span *ngIf="(submitted && formGroup.get('email')?.errors) || !formGroup.get('email')?.valid && formGroup.get('email')?.touched">Please enter email </span>
                        </mat-error>
                      </div>
                  </div>
                  <div class="col-md-6 m-3">
                    <div class="form-group">
                        <label for="" class="form-label"  >Password<span (click)="forgotpasssword();stopPropagation($event)" class="text-info" style="margin-left: 176px;" >Forgot Password</span></label>
                        <div class="input-group" style="width: 177%;">
                            <input type="password"  placeholder="" class="form-control" formControlName="password" (click)="stopPropagation($event)">
                        </div>
        
                        <mat-error>
                          <span *ngIf="(submitted && formGroup.get('password')?.errors) || !formGroup.get('password')?.valid && formGroup.get('password')?.touched">Please enter password </span>
                      </mat-error>
        
                        
                        
                    </div>
                  </div>
                 
              </form>
    
              
              <div class="col-md-12  m-3">
                <div class="col-md-10 ">
                  <button type="submit" class="btn btn-secondary btn-info " style="width:106%;background-color: #F44C4C;
                  border: aliceblue;border-radius: 1px;height:48px;font-weight: 700;
                            font-size: 15px;
                            line-height: 36px;letter-spacing: 0.5px;" (click)="onSubmit();stopPropagation($event)"  >SIGN  IN <i class="ri-arrow-right-line" style="font-weight: 500;"></i></button>
                   
                </div>
               </div>
               </div>
    
    
               <div *ngIf="loginn==false">
    
                <form class="g-3"  [formGroup]="forgotpasswordform"    >
                  <div class="col-md-6 m-3">
                      <div class="form-group">
                          <label for="" class="form-label">Email Address </label>
                          <div class="input-group" style="width: 177%;">
                              <input type="text" placeholder="" class="form-control" formControlName="email" (click)="stopPropagation($event)">
                          </div>
        
                          <mat-error>
                            <span *ngIf="(submitted && forgotpasswordform.get('email')?.errors) || !forgotpasswordform.get('email')?.valid && forgotpasswordform.get('email')?.touched">Please enter email </span>
                        </mat-error>
         
                          
                          
                      </div>
                  </div>
                  <div class="col-md-6 m-3">
                    <div class="form-group">
                      <label>  <span (click)="forgotpasssword();stopPropagation($event)" class="text-info" (click)=signnin()  >Sign In</span></label>
                     
        
                        
                        
                    </div>
                  </div>
                 
              </form>
    
              
              <div class="col-md-12  m-3">
                <div class="col-md-10 ">
                  <button type="submit" class="btn btn-secondary btn-info " style="width:106%;background-color: #F44C4C;
                  border: aliceblue;border-radius: 1px;height:48px;font-weight: 700;
                            font-size: 15px;
                            line-height: 36px;letter-spacing: 0.5px;" (click)="forgotpassword();stopPropagation($event)"  >Forgot Password<i class="ri-arrow-right-line" style="font-weight: 500;"></i></button>
                   
                </div>
               </div>
               </div>
               <!-- <hr> -->
               <!-- <div class="col-md-12 ps-3">
                <div class="col-md-11">
                   
                    <div class="col-md-12" >
                      <div class="col-md-12">
                          <input type="text" class="form-control">
                          <img src="/assets/images/google.png" style="width: 20px; height: 20px;margin-top: -55px;margin-left: 12px;">
                          <p  style="margin-top: -49px;margin-left: 114px;">LogIn with Google</p>
                          
                      </div>
                  </div>
        
                    <!-- <mat-error>
                        <span *ngIf="(submitted && formGroup.get('xrayType').errors) || !formGroup.get('xrayType').valid && formGroup.get('xrayType').touched">Please Enter Type X-Ray Name</span>
                    </mat-error> 
        
                    
                    
                </div>
            </div>
            <div class="col-md-12 ps-3">
              <div class="col-md-11">
                 
                  <div class="col-md-12" >
                    <div class="col-md-12">
                        <input type="text" class="form-control">
                        <img src="/assets/images/apple-logo.png" style="width: 20px; height: 20px;margin-top: -65px;margin-left: 14px;">
                        <p  style="margin-top: -52px;margin-left: 114px;">LogIn with Apple</p>
                        
                    </div>
                </div>
        
                  <!-- <mat-error>
                      <span *ngIf="(submitted && formGroup.get('xrayType').errors) || !formGroup.get('xrayType').valid && formGroup.get('xrayType').touched">Please Enter Type X-Ray Name</span>
                  </mat-error> 
        
                  
                  
              </div>
            </div> -->
              </div>
              <div class="col-md-12 col-md-12 col-lg-12 col-xl-12 p-3" *ngIf="showSignUp">
                <form class="g-3"  [formGroup]="SignUpForm"    >  
                  <div class="col-md-6 m-3">
                      <div class="form-group">
                          <label for="" class="form-label" >First Name </label>
                          <div class="input-group" style="width: 177%;">
                              <input type="text" placeholder="" class="form-control" formControlName="firstName" (keypress)="keyPressAlphabets($event)"  (click)="stopPropagation($event)">
                          </div>
        
                          <mat-error>
                              <span *ngIf="(submitted && SignUpForm.get('firstName')?.errors) || !SignUpForm.get('firstName')?.valid && SignUpForm.get('firstName')?.touched">Please enter first name </span>
                          </mat-error>
        
                          
                          
                      </div>
                  </div>
                  <div class="col-md-6 m-3">
                    <div class="form-group">
                        <label for="" class="form-label" >Last Name </label>
                        <div class="input-group" style="width: 177%;">
                            <input type="text" placeholder="" class="form-control" formControlName="lastName" (keypress)="keyPressAlphabets($event)"  (click)="stopPropagation($event)">
                        </div>
      
                        <mat-error>
                            <span *ngIf="(submitted && SignUpForm.get('lastName')?.errors) || !SignUpForm.get('lastName')?.valid && SignUpForm.get('lastName')?.touched">Please enter  last name </span>
                        </mat-error> 
      
                        
                        
                    </div>
                </div>
                  <div class="col-md-6 m-3">
                    <div class="form-group">
                        <label for="" class="form-label">Email Address</label>
                        <div class="input-group" style="width: 177%;">
                            <input type="text"  placeholder="" class="form-control" formControlName="email"  (click)="stopPropagation($event)" >
                        </div>
        
                        <mat-error>
                            <span *ngIf="(submitted && SignUpForm.get('email')?.errors) || !SignUpForm.get('email')?.valid && SignUpForm.get('email')?.touched">Please enter email</span>
                        </mat-error>
        
                        
                        
                    </div>
                  </div>
                  <div class="col-md-6 m-3">
                    <div class="form-group">
                        <label for="" class="form-label">Phone Number</label>
                        <div class="input-group" style="width: 177%;">
                            <input type="text"  placeholder="" class="form-control" formControlName="mobile" (click)="stopPropagation($event)" (keypress)="keyPressNumbers($event)" [maxLength]="10">
                        </div>
        
                        <mat-error>
                            <span *ngIf="(submitted && SignUpForm.get('mobile')?.errors) || !SignUpForm.get('mobile')?.valid && SignUpForm.get('mobile')?.touched">Please Enter mobile number</span>
                        </mat-error>
                    </div>
                  </div>

                  <div class="col-md-6 m-3">
                    <div class="form-group">
                        <label for="" class="form-label">Password</label>
                        <div class="d-flex position-relative" style="width: 177%;">
                            <input type="password" [type]="fieldTextType ? 'text' : 'password'"  placeholder="password" class="form-control" formControlName="password" (click)="stopPropagation($event)">
                                <i class="bx bxs-show align-middle position-absolute end-0 top-0 pe-3 pt-2 mt-1" *ngIf="!fieldTextType" (click)="toggleFieldTextType(); stopPropagation($event)" style="font-size: 18px;"></i>
                                <i class="bx bxs-hide align-middle position-absolute end-0 top-0 pe-3 pt-2 mt-1" *ngIf="fieldTextType" (click)="toggleFieldTextType(); stopPropagation($event)" style="font-size: 18px;"></i>
                        </div>
                        <mat-error>
                            <span *ngIf="(submitted && SignUpForm.get('password')?.errors) || !SignUpForm.get('password')?.valid && SignUpForm.get('password')?.touched">Please enter password </span>
                        </mat-error>
                    </div>
                  </div>
                  <div class="col-md-6 m-3">
                    <div class="form-group">
                        <label for="" class="form-label">Confirm  Password</label>
                        <div class="d-flex position-relative" style="width: 177%;">
                            <input [type]="fieldTextType1 ? 'text' : 'password'"  placeholder="Confirm password" class="form-control" formControlName="confirmPassword" (click)="stopPropagation($event)" >
                            <i class="bx bxs-show align-middle position-absolute end-0 top-0 pe-3 pt-2 mt-1" *ngIf="!fieldTextType1" (click)="toggleFieldTextType1(); stopPropagation($event)" style="font-size: 18px;"></i>
                            <i class="bx bxs-hide align-middle position-absolute end-0 top-0 pe-3 pt-2 mt-1" *ngIf="fieldTextType1" (click)="toggleFieldTextType1(); stopPropagation($event)" style="font-size: 18px;"></i>
                        </div>
                        <mat-error>
                            <!-- <span *ngIf="(submitted && SignUpForm.get('confirmPassword')?.errors) || !SignUpForm.get('confirmPassword')?.valid && SignUpForm.get('confirmPassword')?.touched">Please enter password </span> -->
                            <span class="text-start" *ngIf="confirmPassword.errors?.notEquivalent && SignUpForm.get('confirmPassword')?.touched">
                                Password does not match
                            </span>
                        </mat-error>
                    </div>
                  </div>
                 
                  <!-- <div class="col-md-6 m-3 d-flex"  (click)="stopPropagation($event)">
                 <div class="col-md-1">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                   
                  </div>
                 </div>
                 <div class="col-md-5"  (click)="stopPropagation($event)">
                  <P  >Are you agree to <span style="font-weight: 500;color:#2DA5F3;font-size: 14px;">Terms of Condition</span> and <br><span style="font-weight: 500;color:#2DA5F3;font-size: 14px;">Privacy Policy</span>.</P>
                 </div>
                  </div> -->
                  
              </form>
              <div class="col-md-12  m-3" (click)="stopPropagation($event)">
                <div class="col-md-10">
                  <button  type="submit" class="btn btn-secondary btn-info " style="width: 106%;background-color: #F44C4C;
                  border: aliceblue;border-radius: 1px;height:48px;font-weight: 700;
                            font-size: 15px;
                            line-height: 36px;letter-spacing: 0.5px;" (click)="submit()"  >SIGN UP <i class="ri-arrow-right-line" style="font-weight: 500;"></i></button>
                </div>
               </div>
               <!-- <hr> -->
               <!-- <div class="col-md-12 ps-3"  (click)="stopPropagation($event)">
                <div class="col-md-11">
                  
                    <div class="col-md-12" (click)="stopPropagation($event)">
                      <div class="col-md-12">
                          <input type="text" class="form-control">
                          <img src="/assets/images/google.png" style="width: 20px; height: 20px;margin-top: -55px;margin-left: 12px;">
                          <p  style="margin-top: -49px;margin-left: 114px;">LogIn with Google</p>
                          
                      </div>
                  </div>
        
                   
        
                    
                    
                </div>
            </div>
            <div class="col-md-12 ps-3">
              <div class="col-md-11">
                
                  <div class="col-md-12" (click)="stopPropagation($event)">
                    <div class="col-md-12">
                        <input type="text" class="form-control">
                        <img src="/assets/images/apple-logo.png" style="width: 20px; height: 20px;margin-top: -65px;margin-left: 14px;">
                        <p  style="margin-top: -52px;margin-left: 114px;">LogIn with Apple</p>
                        
                    </div>
                </div>
        
                
        
                  
                  
              </div>
            </div> -->
            
              </div>
            </div>
          </div>
    
        </a>
      </div>
      </div>
       </div>
      </div>
     </div>
  </div>

</header>
<!--end header-->
